import { useContext } from "react";
import DrawerStackContext from "Components/Organisms/DrawerStackProvider/DrawerStackContext";

export default function useDrawerStack() {
    const context = useContext(DrawerStackContext);

    if (!context) {
        throw new Error("useDrawerStack must be used within a DrawerStackProvider");
    }

    return context;
}